import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { logPageView } from "../../analytics";

import Profile from "../UserSettings/Profile";
import Settings from "../UserSettings/Settings";
import Notifications from "../UserSettings/Notifications";
import CloudMain from "../CloudStorage/CloudMain";
import DeletedCloud from "../CloudStorage/DeletedCloud";
import MainApi from "../API/MainApi";
import NewAccess from "../Access/NewAccess";
import MainAccess from "../Access/MainAccess";
import UpdateAccess from "../Access/UpdatesAccess";
import MainDatabase from "../Database/MainDatabase";
import NewDatabaseNoSQL from "../Database/NewDatabaseNoSQL";
import OpenDatabase from "../Database/OpenDatabase/OpenDatabase";
import MainErioonAI from "../../ErioonAI/MainErioonAI";
import MainBackup from "../Backup/MainBackup";
import InitialSetupItem from "../../Components/InitialSetupItem";
import MainNetwork from "../Network/MainNetwork";
import NewCluster from "../Clusters/NewCluster";
import MainCluster from "../Clusters/MainCluster";
import OpenCluster from "../Clusters/OpenCluster/OpenCluster";
import LoadingClusterCreation from "../Clusters/LoadingClusterCreation";
import MainPlaybox from "../Playbox/MainPlaybox";
import NewPlaybox from "../Playbox/NewPlaybox";
import OpenPlaybox from "../Playbox/OpenPlaybox/OpenPlaybox";
import DeploymentsMain from "../Deployments/DeploymentsMain";
import NewDeployment from "../Deployments/NewDeployment";
import OpenDeployment from "../Deployments/OpenDeployment";
import ChooseDbType from "../Database/ChooseDBType";
import NewDatabaseSQL from "../Database/NewDatabaseSQL";

function ProjectView({ userData }) {
  const location = useLocation();

  useEffect(() => {
    logPageView(location.pathname + location.search);
  }, [location]);

  return (
    <div className="main_view_container">
      <InitialSetupItem />
      <Routes>
        <Route path="profile" element={<Profile userData={userData} />} />
        <Route path="settings" element={<Settings userData={userData} />} />
        <Route path="notifications" element={<Notifications userData={userData} />} />

        {/* Access */}
        <Route path="access" element={<MainAccess userData={userData} />} />
        <Route path="access/new_access" element={<NewAccess userData={userData} />} />
        <Route path="access/update_access/:access_id" element={<UpdateAccess userData={userData} />} />

        {/* API */}
        <Route path="api" element={<MainApi />} />

        {/* Network */}
        <Route path="network" element={<MainNetwork />} />

        {/* Cloud Storage */}
        <Route path="cloud_storage" element={<CloudMain userData={userData} />} />
        <Route path="deleted_files" element={<DeletedCloud userData={userData} />} />

        {/* Database */}
        <Route path="databases" element={<MainDatabase userData={userData} />} />
        <Route path="databases/new_db_type" element={<ChooseDbType userData={userData} />} />
        <Route path="databases/new_database_nosql" element={<NewDatabaseNoSQL userData={userData} />} />
        <Route path="databases/new_database_sql" element={<NewDatabaseSQL userData={userData} />} />
        <Route path="databases/:db_id/:link_db" element={<OpenDatabase userData={userData} />} />
        <Route path="databases/:db_id/:link_db/:coll_id" element={<OpenDatabase userData={userData} />} />

        {/* Backup */}
        <Route path="backup" element={<MainBackup userData={userData} />} />

        {/* Erioon AI */}
        <Route path="erioon-ai" element={<MainErioonAI userData={userData} />} />

        {/* Clusters */}
        <Route path="clusters" element={<MainCluster userData={userData} />} />
        <Route path="clusters/new_cluster" element={<NewCluster userData={userData} />} />
        <Route path="clusters/loading_cluster/:clus_id" element={<LoadingClusterCreation userData={userData} />} />
        <Route path="clusters/:clus_id" element={<OpenCluster userData={userData} />} />
        <Route path="clusters/:clus_id/:link_page" element={<OpenCluster userData={userData} />} />

        {/* Playbox */}
        <Route path="playbox" element={<MainPlaybox userData={userData} />} />
        <Route path="playbox/new_playbox" element={<NewPlaybox userData={userData} />} />
        <Route path="playbox/:playbox_id" element={<OpenPlaybox userData={userData} />} />
        <Route path="playbox/:playbox_id/:link_page" element={<OpenPlaybox userData={userData} />} />

        {/* Deployments */}
        <Route path="deployments" element={<DeploymentsMain userData={userData} />} />
        <Route path="deployments/new_deployment" element={<NewDeployment userData={userData} />} />
        <Route path="deployments/:deployment_id/:link_page" element={<OpenDeployment userData={userData} />} />



      </Routes>
    </div>
  );
}

export default ProjectView;
